import { useAppSelector } from '@/redux/hooks'
import { selectEditMode } from '@/redux/ui/uiSlice'

/**
 * Whether the global Edit Mode toggle is currently on.
 *
 * This hook is a transparent wrapper around `selectEditMode` and exists only to
 * keep the remaining raw reads of that selector in one place while they are
 * migrated. Don't add new call sites!
 *
 * @deprecated Edit Mode is being retired. Use `useIsEditModeSatisfied` from
 * `@/hooks/useIsEditModeSatisfied` instead as that checks both the feature
 * flag (`removeEditMode`) and Edit Mode.
 */
export const useIsEditMode = (): boolean => useAppSelector(selectEditMode)
